import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function ProjectsPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const experiences = [
    {
      id: 1,
      title: 'Regulatory EU HTA-Joint scientific consultations',
      category: 'regulatory',
      organization: 'European Commission',
      duration: '2025 - 2027',
      location: 'Berlin',
      description: 'Joint scientific consultations of EU Health technology assessment of medical devices and products specializing in Horizon Europe Cluster 1 (Health) and Cluster 6 (AgroTech/ FoodTech). Leading regulatory assessments and providing expert guidance on health technology assessment frameworks.',
      outcomes: [
        'Leading joint scientific consultations for innovative medical devices',
        'Specializing in Horizon Europe health and agro-food technology proposals',
        'Providing strategic regulatory guidance for EU health technology assessment'
      ],
      technologies: ['Medical Devices', 'HTA Framework', 'Horizon Europe', 'Regulatory Strategy'],
      image: 'https://static.readdy.ai/image/cdda583d3b14aa1daf8ea5ccc5d6b52c/ddbc3425c020973fd5bed7a67d1e20b1.jpeg'
    },
    {
      id: 2,
      title: 'Med-Tech Startup Consulting',
      category: 'consulting',
      organization: 'Treage (Digital Healthcare Startup)',
      duration: '07/2024 - 09/2024',
      location: 'Berlin',
      description: 'Provided scientific advice and innovation guidance under the 2024 Berlin Startup Stipendium at FU, under the Profound Innovation Hub. Strategic consulting for digital healthcare platform development and market positioning.',
      outcomes: [
        'Delivered scientific advisory for digital healthcare innovation',
        'Guided product development strategy and clinical validation approach',
        'Supported Berlin Startup Stipendium application and innovation framework'
      ],
      technologies: ['Digital Healthcare', 'Med-Tech Innovation', 'Startup Strategy', 'Healthcare Innovation'],
      image: 'https://readdy.ai/api/search-image?query=Back%20view%20of%20Indian%20young%20female%20doctor%20with%20straight%20black%20neck-length%20bob%20haircut%20that%20covers%20her%20ears%2C%20wearing%20white%20medical%20lab%20coat%2C%20reviewing%20patient%20medical%20files%20and%20documents%20on%20desk%20in%20professional%20medical%20office%2C%20focus%20on%20back%20of%20head%20showing%20sleek%20black%20bob%20hairstyle%2C%20doctor%20examining%20patient%20records%20and%20clinical%20data%2C%20warm%20natural%20lighting%20in%20healthcare%20workspace%2C%20professional%20medical%20environment%2C%20contemporary%20clinical%20setting%20with%20patient%20files%20spread%20on%20desk&width=600&height=400&seq=medtech-doctor-backview-bob&orientation=landscape'
    },
    {
      id: 3,
      title: 'Patent Content Consulting',
      category: 'consulting',
      organization: 'Neurosurgical Medical Equipment Innovation',
      duration: '2023 - Present',
      location: 'Berlin',
      description: 'Providing expert guidance in patent content for neurosurgical medical equipment innovation and drafting patents according to German Patent Office guidelines. Specialized in protecting intellectual property for cutting-edge neurotechnology innovations.',
      outcomes: [
        'Drafted multiple patent applications for neurosurgical innovations',
        'Ensured compliance with German Patent Office requirements',
        'Protected intellectual property for breakthrough medical technologies'
      ],
      technologies: ['Patent Law', 'Neurosurgical Equipment', 'IP Strategy', 'Medical Innovation', 'Healthcare Innovation'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20wooden%20desk%20covered%20with%20scientific%20research%20publications%20and%20patent%20documents%20spread%20out%2C%20neurosurgical%20medical%20equipment%20patent%20blueprints%20and%20technical%20drawings%20visible%2C%20brain%20science%20research%20papers%20and%20medical%20device%20specifications%2C%20intellectual%20property%20documents%20and%20patent%20applications%20on%20table%20surface%2C%20organized%20workspace%20with%20multiple%20scientific%20journals%20and%20patent%20filings%2C%20detailed%20view%20of%20patent%20documentation%20and%20research%20publications%2C%20professional%20lighting%20highlighting%20document%20details%2C%20contemporary%20office%20setting%20focused%20on%20table%20full%20of%20scientific%20and%20patent%20materials&width=600&height=400&seq=patent-publications-table&orientation=landscape'
    },
    {
      id: 4,
      title: 'Science Policy Advising',
      category: 'policy',
      organization: 'Konrad Adenauer Stiftung (KAS)',
      duration: '2023 - Present',
      location: 'Berlin',
      description: 'Invited expert for science innovation policy discussions on Indo-German geo-policy at KAS, Berlin. Contributing to strategic policy development for international scientific collaboration and innovation frameworks.',
      outcomes: [
        'Expert advisor on Indo-German science innovation policy',
        'Contributed to geo-policy discussions on international research collaboration',
        'Shaped policy frameworks for cross-border scientific innovation'
      ],
      technologies: ['Science Policy', 'International Relations', 'Innovation Strategy'],
      image: 'https://static.readdy.ai/image/cdda583d3b14aa1daf8ea5ccc5d6b52c/affc0867e35651b4df9da15fd094c48f.jpeg'
    },
    {
      id: 5,
      title: 'Non-Dilutive Funding Success - TRR186 DFG',
      category: 'research',
      organization: 'Deutsche Forschungsgemeinschaft (DFG)',
      duration: '2024 - 2028',
      location: 'Berlin',
      description: 'Secured 13.5 million euros for 20 group consortia for a second 4-year EU-funded DFG project for cutting-edge in vivo single-molecule imaging project with international collaborations. Leading groundbreaking research in advanced microscopy and molecular neuroscience.',
      outcomes: [
        'Won competitive 4-year DFG grant for second time',
        'Leading cutting-edge in vivo single-molecule imaging research',
        'Managing EU-DFG research projects for 8 years'
      ],
      technologies: ['Single-Molecule Imaging', 'In Vivo Microscopy', 'Neuroscience Research'],
      image: 'https://static.readdy.ai/image/cdda583d3b14aa1daf8ea5ccc5d6b52c/ed6b7ae9f90ce47d24d4c90bf99f5b2c.jpeg'
    },
    {
      id: 6,
      title: 'Scientific Publishing Platform Consulting',
      category: 'consulting',
      organization: 'Morressier Publishing House, AAAS and MIT',
      duration: '2024 - Present',
      location: 'Berlin',
      description: 'Establishing Berlin-based NPO developing cost-saving, revenue-enhancing platform for non-profit publishers in scholarly communication. Initially focusing on climate change research to build cross-disciplinary ecosystem supporting equitable research dissemination.',
      outcomes: [
        'Developing innovative platform for scholarly communication',
        'Formalizing partnerships with global organizations',
        'Securing seed funding for climate research publishing initiative'
      ],
      technologies: ['Scientific Publishing', 'Platform Development', 'Climate Research'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20publishing%20workspace%20showing%20multiple%20scientific%20journal%20manuscripts%20being%20typeset%20and%20compared%20side%20by%20side%20on%20large%20desk%2C%20academic%20journal%20layouts%20with%20visible%20headlines%20about%20neuroscience%20breakthroughs%20and%20climate%20change%20research%2C%20scientific%20articles%20with%20titles%20about%20neural%20networks%20and%20carbon%20emissions%20spread%20across%20table%2C%20editorial%20review%20process%20with%20journal%20formatting%20showing%20climate%20science%20and%20brain%20research%20papers%2C%20scholarly%20publishing%20materials%20with%20neuroscience%20and%20environmental%20science%20journal%20versions%20being%20compared%2C%20detailed%20view%20of%20scientific%20manuscript%20editing%20with%20climate%20change%20and%20neuroscience%20headlines%20visible%2C%20warm%20professional%20lighting%20in%20publishing%20office%20environment%2C%20contemporary%20academic%20publishing%20setting%20with%20journal%20proofs%20featuring%20neuroscience%20and%20climate%20research%20topics&width=600&height=400&seq=publishing-neuro-climate-journals&orientation=landscape'
    },
    {
      id: 7,
      title: 'Indo-German Young Leader',
      category: 'honors',
      organization: '40 Under 40 Forum',
      duration: '2024',
      location: 'Berlin',
      description: 'Selected as delegate and industry expert for prestigious Indo-German Young Leaders Forum. Recognized for contributions to international scientific collaboration and innovation leadership.',
      outcomes: [
        'Selected for prestigious 40 Under 40 leadership program',
        'Representing neurotechnology and life sciences innovation',
        'Building Indo-German scientific and business partnerships'
      ],
      technologies: ['Leadership', 'International Collaboration', 'Innovation'],
      image: 'https://static.readdy.ai/image/cdda583d3b14aa1daf8ea5ccc5d6b52c/6ab63cc314c4646ee36f8f224cbc5b12.jpeg'
    },
    {
      id: 8,
      title: 'Indo-German Health Conference',
      category: 'policy',
      organization: 'International Health Collaboration',
      duration: '2025',
      location: 'Berlin',
      description: 'Executive Board Member, panellist, and moderator for Indo-German Health Conference. Facilitating dialogue between healthcare leaders, researchers, and policymakers from India and Germany.',
      outcomes: [
        'Organizing major international health conference',
        'Moderating panels on healthcare innovation and collaboration',
        'Facilitating Indo-German healthcare partnerships'
      ],
      technologies: ['Healthcare Policy', 'International Collaboration', 'Conference Leadership', 'Healthcare Innovation'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20international%20health%20conference%20with%20Indian%20woman%20in%20elegant%20business%20suit%20presenting%20at%20podium%20in%20foreground%2C%20she%20has%20straight%20neck-length%20black%20bob%20haircut%20that%20covers%20her%20ears%20and%20half%20of%20her%20side%20face%20matching%20the%20appearance%20from%20Indo-German%20Young%20Leaders%20Forum%20photo%2C%20Indian%20and%20German%20flags%20prominently%20displayed%20in%20background%2C%20diverse%20healthcare%20professionals%20in%20formal%20business%20attire%2C%20modern%20conference%20hall%20setting%20with%20healthcare%20innovation%20displays%2C%20sophisticated%20medical%20collaboration%20event%2C%20professional%20photography%20style%2C%20international%20delegation%20atmosphere&width=600&height=400&seq=health-conference-tina-bob&orientation=landscape'
    }
  ];

  const publications = [
    {
      title: 'PNAS Publication',
      journal: 'Proceedings of the National Academy of Sciences',
      date: 'August 2025',
      url: 'https://www.pnas.org/doi/10.1073/pnas.2514151122'
    },
    {
      title: 'Nature Communications',
      journal: 'Nature Communications',
      date: 'January 2025',
      url: 'https://www.nature.com/articles/s41467-024-55382-9'
    },
    {
      title: 'Science Advances',
      journal: 'Science - Science Advances',
      date: 'March 2023',
      url: 'https://www.science.org/doi/10.1126/sciadv.ade7804'
    },
    {
      title: 'Frontiers in Molecular Neuroscience',
      journal: 'Frontiers in Molecular Neuroscience',
      date: 'November 2021',
      url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC8632625/'
    },
    {
      title: 'Frontiers in Neuroanatomy',
      journal: 'Frontiers in Neuroanatomy',
      date: 'October 2018',
      url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6198076/'
    }
  ];

  const training = [
    {
      title: 'EUPATI: HTA and Life Sciences Scale-up Regulatory Framework',
      organization: 'European Patients Academy',
      icon: 'ri-shield-check-line'
    },
    {
      title: 'EU IP Patent Law for Life Sciences',
      organization: 'Technical University of Denmark (DTU) & Copenhagen Business School',
      icon: 'ri-file-shield-line'
    },
    {
      title: 'Patent Training',
      organization: 'Eisenführ Speiser & Leibniz-Institut für Kristallzüchtung',
      icon: 'ri-lightbulb-line'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Experience' },
    { id: 'consulting', name: 'Consulting' },
    { id: 'regulatory', name: 'Regulatory' },
    { id: 'policy', name: 'Policy' },
    { id: 'funding', name: 'Non-dilutive Funding' },
    { id: 'publications', name: 'Recent Publications' },
    { id: 'training', name: 'Additional Professional Training' }
  ];

  const filteredExperiences = selectedCategory === 'all' 
    ? experiences 
    : selectedCategory === 'funding'
    ? experiences.filter(exp => exp.category === 'research')
    : experiences.filter(exp => exp.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
      {/* Navigation */}
      <nav className="bg-white/90 backdrop-blur-sm shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <Link to="/" className="text-lg md:text-2xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent cursor-pointer whitespace-nowrap">
                Dr. Tina Ghelani
              </Link>
            </div>
            {/* Mobile Navigation Links */}
            <div className="flex md:hidden items-center space-x-3 text-xs">
              <Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">About</Link>
              <Link to="/projects" className="text-blue-600 font-medium whitespace-nowrap cursor-pointer">Experience</Link>
              <Link to="/#services" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">Services</Link>
            </div>
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">About</Link>
              <Link to="/#services" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">Services</Link>
              <Link to="/projects" className="text-blue-600 font-medium whitespace-nowrap cursor-pointer">Experience</Link>
              <Link to="/#contact" className="text-gray-700 hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer">Contact</Link>
              <a 
                href="https://calendar.app.google/6szNfxS4wtq3RLBC7"
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-teal-500 hover:bg-teal-600 text-white px-4 py-2 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
              >
                Book Consultation
              </a>
              <a href="https://www.linkedin.com/in/dr-tina-ghelani" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:text-blue-800 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-blue-900 to-teal-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30"
          style={{
            backgroundImage: "url('https://readdy.ai/api/search-image?query=Portfolio%20of%20successful%20neuroscience%20projects%20displayed%20on%20digital%20screens%2C%20brain%20imaging%20data%20and%20neural%20network%20visualizations%2C%20professional%20consulting%20office%20with%20multiple%20monitors%20showing%20project%20outcomes%2C%20sophisticated%20medical%20technology%20presentations&width=1920&height=600&seq=projects-hero&orientation=landscape')"
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-2xl md:text-5xl lg:text-5xl font-bold mb-6">
            Professional Experience
          </h1>
          <p className="text-sm md:text-xl lg:text-2xl text-blue-100 max-w-3xl mx-auto">
            Consulting engagements, regulatory roles, research achievements, and leadership positions across neuroscience and life sciences innovation
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 text-xs md:text-base rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-teal-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Experience Grid */}
      <section className="pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {selectedCategory === 'publications' ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {publications.map((pub, index) => (
                <a
                  key={index}
                  href={pub.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-br from-blue-50 to-teal-50 p-6 rounded-xl hover:shadow-lg transition-shadow cursor-pointer"
                >
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className="ri-article-line text-xl text-white"></i>
                    </div>
                    <div className="flex-1">
                      <h5 className="text-sm md:text-base font-bold text-gray-900 mb-2">{pub.title}</h5>
                      <p className="text-xs md:text-sm text-gray-600 mb-1">{pub.journal}</p>
                      <p className="text-xs text-gray-500">{pub.date}</p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          ) : selectedCategory === 'training' ? (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {training.map((item, index) => (
                <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full flex items-center justify-center mb-6">
                    <i className={`${item.icon} text-2xl text-white`}></i>
                  </div>
                  <h5 className="text-sm md:text-base font-bold text-gray-900 mb-3">{item.title}</h5>
                  <p className="text-xs md:text-sm text-gray-600">{item.organization}</p>
                </div>
              ))}
            </div>
          ) : (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {filteredExperiences.map((experience) => (
                <article key={experience.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                  <div className="relative h-64">
                    <img
                      src={experience.image}
                      alt={`${experience.title} - neuroscience consulting experience`}
                      title={`${experience.title} professional experience`}
                      className={`w-full h-full object-cover ${experience.id === 1 ? 'object-center' : 'object-top'}`}
                    />
                    <div className="absolute top-4 left-4">
                      <span className="px-3 py-1 bg-blue-600 text-white text-xs md:text-sm font-medium rounded-full">
                        {experience.category === 'consulting' && 'Consulting'}
                        {experience.category === 'regulatory' && 'Regulatory'}
                        {experience.category === 'policy' && 'Policy'}
                        {experience.category === 'research' && 'Research'}
                        {experience.category === 'honors' && 'Honors'}
                      </span>
                    </div>
                  </div>
                  
                  <div className="p-8">
                    <div className="flex justify-between items-start mb-4">
                      <h4 className="text-base md:text-xl font-bold text-gray-900 flex-1">
                        <a href={`#experience-${experience.id}`} className="hover:text-blue-600 transition-colors cursor-pointer">
                          {experience.title}
                        </a>
                      </h4>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-4 mb-6 text-xs md:text-sm text-gray-600">
                      <div>
                        <strong>Organization:</strong> {experience.organization}
                      </div>
                      <div>
                        <strong>Duration:</strong> {experience.duration}
                      </div>
                      <div>
                        <strong>Location:</strong> {experience.location}
                      </div>
                    </div>
                    
                    <p className="text-xs md:text-base text-gray-600 mb-6 leading-relaxed">
                      {experience.id === 5 ? (
                        <>
                          Secured 13.5 million euros for 20 group consortia for a second 4-year EU-funded DFG project for cutting-edge <em>in vivo</em> single-molecule imaging project with international collaborations. Leading groundbreaking research in advanced microscopy and molecular neuroscience.
                        </>
                      ) : (
                        experience.description
                      )}
                    </p>
                    
                    <div className="mb-6">
                      <h5 className="text-sm md:text-base font-semibold text-gray-900 mb-3">Key Achievements:</h5>
                      <ul className="space-y-2">
                        {experience.outcomes.map((outcome, index) => (
                          <li key={index} className="flex items-start space-x-3">
                            <div className="w-2 h-2 bg-teal-500 rounded-full mt-2 flex-shrink-0"></div>
                            <span className="text-xs md:text-sm text-gray-700">
                              {experience.id === 5 && outcome.includes('in vivo') ? (
                                <>
                                  {outcome.split('in vivo')[0]}
                                  <em>in vivo</em>
                                  {outcome.split('in vivo')[1]}
                                </>
                              ) : (
                                outcome
                              )}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    
                    <div>
                      <h5 className="text-sm md:text-base font-semibold text-gray-900 mb-3">Focus Areas:</h5>
                      <div className="flex flex-wrap gap-2">
                        {experience.technologies.map((tech, index) => (
                          <span
                            key={index}
                            className="px-3 py-1 bg-gray-100 text-gray-700 text-xs md:text-sm rounded-lg"
                          >
                            {tech === 'In Vivo Microscopy' ? (
                              <>
                                <em>In Vivo</em> Microscopy
                              </>
                            ) : (
                              tech
                            )}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Publications Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-4 text-center">
            Recent Publications
          </h3>
          <p className="text-sm md:text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            Published in prestigious journals including PNAS, Nature Communications, and Science Advances
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {publications.map((pub, index) => (
              <a
                key={index}
                href={pub.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-gradient-to-br from-blue-50 to-teal-50 p-6 rounded-xl hover:shadow-lg transition-shadow cursor-pointer"
              >
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-article-line text-xl text-white"></i>
                  </div>
                  <div className="flex-1">
                    <h5 className="text-sm md:text-base font-bold text-gray-900 mb-2">{pub.title}</h5>
                    <p className="text-xs md:text-sm text-gray-600 mb-1">{pub.journal}</p>
                    <p className="text-xs text-gray-500">{pub.date}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Training & Certifications */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-4 text-center">
            Professional Training
          </h3>
          <p className="text-sm md:text-xl text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            Specialized training in HTA, regulatory frameworks, and patent law for life sciences
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {training.map((item, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-teal-500 rounded-full flex items-center justify-center mb-6">
                  <i className={`${item.icon} text-2xl text-white`}></i>
                </div>
                <h5 className="text-sm md:text-base font-bold text-gray-900 mb-3">{item.title}</h5>
                <p className="text-xs md:text-sm text-gray-600">{item.organization}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Education Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-xl md:text-3xl font-bold text-gray-900 mb-12 text-center">
            Academic Background
          </h3>
          
          <div className="max-w-4xl mx-auto space-y-8">
            <div className="bg-gradient-to-r from-blue-50 to-teal-50 p-8 rounded-xl">
              <div className="flex items-start space-x-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-graduation-cap-line text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h5 className="text-base md:text-xl font-bold text-gray-900 mb-2">Doctor of Natural Sciences (Dr. rer. nat)</h5>
                  <p className="text-sm md:text-lg text-gray-700 mb-2">Georg-August-Universität Göttingen</p>
                  <p className="text-xs md:text-base text-gray-600 mb-4">02/2012 - 05/2016 | Göttingen, Germany</p>
                  <div className="space-y-2">
                    <p className="text-xs md:text-sm text-gray-700"><strong>Honors:</strong> Dorothea Schlözer Mentoring Program (Accelerated Female Academic Talent)</p>
                    <p className="text-xs md:text-sm text-gray-700"><strong>Funding:</strong> CNMPB Cluster of Excellence 171 - DFG Research Center 10 Program</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-teal-50 p-8 rounded-xl">
              <div className="flex items-start space-x-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-microscope-line text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h5 className="text-base md:text-xl font-bold text-gray-900 mb-2">Master of Science in Medical Sciences (M.Sc.)</h5>
                  <p className="text-sm md:text-lg text-gray-700 mb-2">Uppsala University</p>
                  <p className="text-xs md:text-base text-gray-600 mb-4">01/2005 - 2008 | Uppsala, Sweden</p>
                  <p className="text-xs md:text-sm text-gray-700"><strong>Master's Internship:</strong> EMBL, Monterotondo (01/2009 - 09/2009 | Rome/Monterotondo, Italy)</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-blue-50 to-teal-50 p-8 rounded-xl">
              <div className="flex items-start space-x-6">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-flask-line text-2xl text-white"></i>
                </div>
                <div className="flex-1">
                  <h5 className="text-base md:text-xl font-bold text-gray-900 mb-2">Bachelor of Science in Chemistry, Genetics & Molecular Biology (B.Sc)</h5>
                  <p className="text-sm md:text-lg text-gray-700 mb-2">Osmania University</p>
                  <p className="text-xs md:text-base text-gray-600">01/2008 - 09/2009 | Hyderabad, India</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-teal-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-xl md:text-3xl font-bold mb-6">
            Ready to Collaborate on Your Lifescience Project?
          </h3>
          <p className="text-sm md:text-xl mb-8 text-blue-100 max-w-3xl mx-auto">
            Let's discuss how strategic consulting can help advance your life sciences and Med-Tech initiatives and drive success in this rapidly evolving field.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://calendar.app.google/6szNfxS4wtq3RLBC7"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-blue-600 text-sm md:text-base px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Schedule Consultation
            </a>
            <Link 
              to="/#contact"
              className="border-2 border-white text-white hover:bg-white hover:text-blue-600 text-sm md:text-base px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Send Message
            </Link>
            <a 
              href="https://www.linkedin.com/in/dr-tina-ghelani"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white hover:bg-white hover:text-blue-600 text-sm md:text-base px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Connect on LinkedIn
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-blue-400 to-teal-400 bg-clip-text text-transparent mb-4">
                Dr. Tina Ghelani
              </h4>
              <p className="text-xs md:text-base text-gray-400 mb-4">
                Expert life sciences consulting with neuroscience specialization
              </p>
              <a href="https://www.linkedin.com/in/dr-tina-ghelani" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
            </div>
            
            <div>
              <h5 className="text-sm md:text-base font-semibold mb-4">Services</h5>
              <ul className="space-y-2 text-xs md:text-base text-gray-400">
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">Strategic Consulting</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">Regulatory Strategy</Link></li>
                <li><Link to="/#services" className="hover:text-white transition-colors cursor-pointer">Investment Advisory</Link></li>
              </ul>
            </div>
            
            <div>
              <h5 className="text-sm md:text-base font-semibold mb-4">Quick Links</h5>
              <ul className="space-y-2 text-xs md:text-base text-gray-400">
                <li><Link to="/about" className="hover:text-white transition-colors cursor-pointer">About</Link></li>
                <li><Link to="/projects" className="hover:text-white transition-colors cursor-pointer">Experience</Link></li>
                <li><Link to="/#contact" className="hover:text-white transition-colors cursor-pointer">Contact</Link></li>
                <li>
                  <a 
                    href="https://calendar.app.google/6szNfxS4wtq3RLBC7"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white transition-colors cursor-pointer"
                  >
                    Book Consultation
                  </a>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-xs md:text-base text-gray-400">
            <p>&copy; 2024 Dr. Tina Ghelani. All rights reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}
